/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignUser } from '../fn/agn-resource/assign-user';
import { AssignUser$Params } from '../fn/agn-resource/assign-user';
import { findById4 } from '../fn/agn-resource/find-by-id-4';
import { FindById4$Params } from '../fn/agn-resource/find-by-id-4';
import { findResourceAvailabilities } from '../fn/agn-resource/find-resource-availabilities';
import { FindResourceAvailabilities$Params } from '../fn/agn-resource/find-resource-availabilities';
import { findResources } from '../fn/agn-resource/find-resources';
import { FindResources$Params } from '../fn/agn-resource/find-resources';
import { getRestrictedResources } from '../fn/agn-resource/get-restricted-resources';
import { GetRestrictedResources$Params } from '../fn/agn-resource/get-restricted-resources';
import { Resource } from '../models/resource';
import { ResourceAvailability } from '../models/resource-availability';
import { unassignUser } from '../fn/agn-resource/unassign-user';
import { UnassignUser$Params } from '../fn/agn-resource/unassign-user';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class AgnResourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `unassignUser()` */
  static readonly UnassignUserPath = '/api/agn-resources/{id}/unassign-user/{user-id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unassignUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  unassignUser$Response(params: UnassignUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return unassignUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unassignUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unassignUser(params: UnassignUser$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.unassignUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `assignUser()` */
  static readonly AssignUserPath = '/api/agn-resources/{id}/assign-user/{user-id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignUser$Response(params: AssignUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return assignUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignUser(params: AssignUser$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.assignUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `findResources()` */
  static readonly FindResourcesPath = '/api/agn-resources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findResources()` instead.
   *
   * This method doesn't expect any request body.
   */
  findResources$Response(params?: FindResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
    return findResources(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findResources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findResources(params?: FindResources$Params, context?: HttpContext): Observable<Array<Resource>> {
    return this.findResources$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Resource>>): Array<Resource> => r.body)
    );
  }

  /** Path part for operation `findById4()` */
  static readonly FindById4Path = '/api/agn-resources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById4()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById4$Response(params: FindById4$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    return findById4(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById4(params: FindById4$Params, context?: HttpContext): Observable<Resource> {
    return this.findById4$Response(params, context).pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `getRestrictedResources()` */
  static readonly GetRestrictedResourcesPath = '/api/agn-resources/restricted-resources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRestrictedResources()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRestrictedResources$Response(params: GetRestrictedResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
    return getRestrictedResources(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRestrictedResources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRestrictedResources(params: GetRestrictedResources$Params, context?: HttpContext): Observable<Array<Resource>> {
    return this.getRestrictedResources$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Resource>>): Array<Resource> => r.body)
    );
  }

  /** Path part for operation `findResourceAvailabilities()` */
  static readonly FindResourceAvailabilitiesPath = '/api/agn-resources/availability';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findResourceAvailabilities()` instead.
   *
   * This method doesn't expect any request body.
   */
  findResourceAvailabilities$Response(params: FindResourceAvailabilities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceAvailability>>> {
    return findResourceAvailabilities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findResourceAvailabilities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findResourceAvailabilities(params: FindResourceAvailabilities$Params, context?: HttpContext): Observable<Array<ResourceAvailability>> {
    return this.findResourceAvailabilities$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResourceAvailability>>): Array<ResourceAvailability> => r.body)
    );
  }

}
